import { serverTimestamp, type FieldValue } from 'firebase/firestore'
import {
  typedCollection,
  typedDoc,
  getCollection,
  updateDocument,
  deleteDocument,
  addDoc,
  orderBy,
} from '@/lib/firebase/firestore'
import type { PositionDocument } from '@/types'

const positionsCol = () => typedCollection<PositionDocument>('positions')

type PositionCreatePayload = Omit<PositionDocument, 'id' | 'createdAt' | 'updatedAt'> & {
  createdAt: FieldValue
  updatedAt: FieldValue
}

export const adminPositionsService = {
  async createPosition(title: string, order: number, group?: string): Promise<string> {
    const payload: PositionCreatePayload = {
      title: title.trim(),
      order,
      isActive: true,
      ...(group?.trim() ? { group: group.trim() } : {}),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    }
    const ref = await addDoc(positionsCol(), payload as unknown as PositionDocument)
    return ref.id
  },

  async updatePosition(
    id: string,
    data: Partial<Pick<PositionDocument, 'title' | 'order' | 'isActive'>> & { group?: string | null }
  ): Promise<void> {
    const ref = typedDoc<PositionDocument>('positions', id)
    const updates: Record<string, unknown> = { updatedAt: serverTimestamp() }
    if (data.title !== undefined) updates.title = data.title.trim()
    if (data.order !== undefined) updates.order = data.order
    if (data.isActive !== undefined) updates.isActive = data.isActive
    if (data.group !== undefined) updates.group = data.group?.trim() || null
    await updateDocument(ref, updates as unknown as PositionDocument)
  },

  async deletePosition(id: string): Promise<void> {
    const ref = typedDoc<PositionDocument>('positions', id)
    await deleteDocument(ref)
  },

  async getAllPositions(): Promise<Array<PositionDocument & { id: string }>> {
    return getCollection(positionsCol(), orderBy('order', 'asc'))
  },
}
